<template>

  <day-base-bar>
    <div class="text-right fill-height pe-2" style="background-color: rgb(from #5456aa r g b / 40%)">
      {{ item.spacesSold }}
    </div>
  </day-base-bar>

</template>

<script setup lang="ts">

import DayBaseBar from './DayBaseBar.vue'
import type { DaySummaryWithParcsInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: DaySummaryWithParcsInventoryCalendarItem
}

defineProps<Props>()

</script>
